export function normalizeString(string: string | undefined): string {
  string = string ? string.trim().toLowerCase() : '';
  return string.normalize
    ? string
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    : string;
}
